import RecoverStep from "../recover_step";
import {attachSelectableHandler, getFormattedDateTime, showVmsList} from "../../utils/recover_utils";

const TEMPLATE = 'export-failover-vm';

export default class SetVmExportFailover extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }
    open(data, el, fr, previousStep) {
        let running = false;
        let rendered = false;
        if (data.recovery.virtualization.running) {
            running = true;
        } else {
            rendered = true;
        }

        data.render = {
            isLoading    : false,
            isSuccessful : false,
            vmRunning    : running,
            vmRendered   : rendered,
            date         : (data.recovery.virtualization.pointTs ? getFormattedDateTime(new Date(data.recovery.virtualization.pointTs * 1000)) : "Unknown"),
            clientId     : data.clientId,
            format       : data.recovery.virtualization.format
        };
        fr.render('setVmExportFailover');
    }


    postRender(data, el, fr) {
        attachSelectableHandler(el,(d) => {
            data.restore.type = d.type;
        });
    }

    transitionViewService(data, el, fr) {
        showVmsList(data);
    }

    transitionBack(data, el, fr) {
        delete data.recovery.device_id;
        if (data.recovery.virtualization.running) {
            fr.goTo('locateVirtualization');
        } else {
            fr.goTo(data.tmp.previousStep);
        }
    }

    transitionProceed(data, el, fr) {
        fr.goTo("exportVmFailover");
    }

}
